export default {
    STEPPER_INCREASE: 'stepper-increase',
    STEPPER_DECREASE: 'stepper-decrease',
    STEPPER_CHANGE: 'stepper-change',
};
